type Props = {
    children: string;
};

export function Clamp({ children }: Props) {
    return (
        <span className="atml-clamp-3-lines" title={children}>
            {children}
        </span>
    );
}
